<template>
<div>
    <loader v-if="loading" />
    <div v-if="!loading && data">
        <v-layout row wrap>
            <v-flex v-if="data.Enrolment > 0" :xs6="data.Turnout > 0 ? true : false"  :sm12="data.Turnout > 0 ? true : false" :md6="data.Turnout > 0 ? true : false">
                <count-up :endVal="data.Enrolment" text="Enrolment" />
            </v-flex>
            <v-flex xs6 sm12 md6 class="mt-sm-3" v-if="data.Turnout > 0">
                <count-up 
                :endVal="data.Turnout" 
                text="Turnout" 
                :countOptions="{
                    suffix: '%',
                    decimalPlaces: 2
                }" />
            </v-flex>
            <!-- <v-flex sm4 v-if="data.Informality > 0">
                <count-up :endVal="data.Informality" text="Informality" />
            </v-flex> -->
        </v-layout>
    </div>
</div>
</template>
<script>
    import Loader from '@/components/Loader.vue';
    import CountUp from '../StatisticalInformation/CountUp.vue';
    import axios from 'axios';
    window.Handbook = window.Handbook || {}
    const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
    axios.defaults.baseURL = apiUri;
    export default {
        props: ['division', 'year', 'electionId'],
        components: {
            Loader,
            CountUp
        },
        data() {
            return {
                data: {},
                loading: true
            }
        },
        created() {
            this.initialiseData();
        },
        methods: {
            initialiseData: function () {
                const url = `Elections/DivisionStatistics?divisionName=${this.division}&year=${this.year}&electionId=${this.electionId}`;
                axios.get(`api/${url}`)
                    .then(response => {
                        this.data = response.data;
                        this.loading = false;
                    });
            }
        }
    }
</script>